import type { IContextMutationResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextMutation } from '@modules/core/services/query';

import type { IReportChangeTabNamePayload } from '../types';
import {
  REPORT_CHANGE_TAB_NAME_API_URL,
  REPORT_CHANGE_TAB_NAME_MUTATION,
} from '../constants';

export default function useReportChangeTabNameMutation(): IContextMutationResult<void, Error, IReportChangeTabNamePayload> {
  const { fetchPut } = useRestClient();

  return useContextMutation<void, Error, IReportChangeTabNamePayload>({
    mutationKey: [REPORT_CHANGE_TAB_NAME_MUTATION],
    mutationFn: ({
      options: {
        reportType,
        permission,
        widgetType,
      },
      tabId,
      ...payload
    }) => fetchPut<void>(
      REPORT_CHANGE_TAB_NAME_API_URL,
      payload,
      {
        permission,
        urlParams: {
          reportType,
          widgetType,
          tabId,
        },
      },
    ),
  });
}
